<template>
  <form-wrapper :validator="$v.items">

    <h3 style="text-align:center;">{{ $t('message.h3Udaje') }}</h3>
    <b-form-row>
      <b-col cols="5">

        <div class="row">
          <div class="col-md-5">
            <label class="percentLabel">{{ $t('message.lblPercent') }}</label>
          </div>
          <div class="col-md-7">
            <b-form-radio-group
              v-model="items.percent"
              :options="listPercents"
              stacked
              plain
              @input="setNull"
            />
          </div>
        </div>

        <bubble-message
          :message="diki"
          :img="false"
        />

        <transition
          name="fade"
          mode="out-in"
        >
          <bubble-message
            v-if="items.percent == 3"
            :message="$t('message.helpPercent')"
            :img="true"
          />
        </transition>
      </b-col>

      <transition
        name="fade"
        mode="out-in"
      >
        <b-col v-if="items.percent !== 0">
          <b-form-group
            :label="$t('message.lblIco')">
            <b-form-input
              class="alignL"
              :state="$v.items.podiel_ico.$dirty ? !$v.items.podiel_ico.$invalid : null"
              v-model.trim="$v.items.podiel_ico.$model"
            />
            <p
              style="color: #dc3545"
              v-if="!$v.items.podiel_ico.maxLength"
            >
              Môže obsahovať najviac 13 znakov.
            </p>
            <p
              style="color: #dc3545"
              v-if="!$v.items.podiel_ico.numeric"
            >
              Nesmie byť písmeno.
            </p>
            <a
              href="#"
              style="text-decoration: underline;"
              @click="addZuskData"
            >
              "ZÚSK - Združenie účtovníkov Slovenska"
            </a>
          </b-form-group>

          <text-group
            v-for="(item, key) in textGroupItems"
            :key="key"
            :align-right="false"
            :m="items"
            :name="key"
            :label="item.label"
            :hint="item.hint"
          />

          <b-form-group
            name="podiel_suhlas"
            label=""
          >
            <template slot-scope="{ attrs, listeners }">
              <b-form-checkbox
                v-bind="attrs"
                v-model="items.podiel_suhlas"
                value="1"
                unchecked-value="0"
                plain
                v-on="listeners"
              >
                {{ $t('message.lblSuhlasim') }}
              </b-form-checkbox>
            </template>
          </b-form-group>

        </b-col>
      </transition>
    </b-form-row>

    <b-button
      class="btn-primary"
      @click="save"
    >
      {{ $t('message.lblSave') }}
    </b-button>
  </form-wrapper>
</template>

<script>
import { required, requiredIf, maxLength, numeric } from 'vuelidate/lib/validators'
import bFormGroup from '@/components/form-group-col6'
import textGroup from '@/components/extractor/textGroup.vue'
import restEditor from '@/mixins/restEditor'
import bubbleMessage from '@/components/bubbleMessage.vue'
import { mustCheck } from '@/validators'

export default {
  components: {
    bFormGroup,
    textGroup,
    bubbleMessage
  },

  mixins: [restEditor],

  data() {
    return {
      listPercents: [
        { text: this.$t('message.lblNeuplatnuje'), value: 0 },
        { text: this.$t('message.lblPercent1'), value: 2 },
        { text: this.$t('message.lblPercent2'), value: 3 }
      ],
      items: {
        percent: 0,
        podiel_ico: null,
        podiel_pravna_forma: null,
        podiel_obch_meno1: null,
        podiel_obch_meno2: null,
        podiel_ulica: null,
        podiel_cislo: null,
        podiel_psc: null,
        podiel_obec: null,
        podiel_suhlas: null
      },
      textGroupItems: {
        podiel_pravna_forma: { label: this.$t('message.lblPravnaForma') },
        podiel_obch_meno1: { label: this.$t('message.lblObchMeno1') },
        podiel_obch_meno2: { label: this.$t('message.lblObchMeno2') },
        podiel_ulica: { label: this.$t('message.lblUlica') },
        podiel_cislo: { label: this.$t('message.lblCislo') },
        podiel_psc: { label: this.$t('message.lblPsc') },
        podiel_obec: { label: this.$t('message.lblObec') }
      },
      diki: 'Pri vyplňovaní Vášho daňového priznania sa môžete rozhodnúť, ktorej organizácii poukážete svoj podiel zaplatenej dane. Zdvorilo sa na Vás obraciame s prosbou poukázať podiel zaplatenej dane občianskemu združeniu "ZÚSK - Združenie účtovníkov Slovenska", ktorý by sme radi použili na podporu profesie účtovníkov a personalistov, organizovanie spoločenských a vzdelávacích podujatí a podporu takých projektov, ako je portál www.jednoduche.sk. Ďakujeme Vám!'
    }
  },

  validations: {
    items: {
      percent: { required },
      podiel_ico: {
        required: requiredIf(vm => (vm.percent !== 0)),
        numeric,
        maxLength: maxLength(13)
      },
      podiel_pravna_forma: {
        required: requiredIf(vm => (vm.percent !== 0)),
        maxLength: maxLength(23)
      },
      podiel_obch_meno1: {
        required: requiredIf(vm => (vm.percent !== 0)),
        maxLength: maxLength(40)
      },
      podiel_obch_meno2: { maxLength: maxLength(37) },
      podiel_ulica: {
        required: requiredIf(vm => (vm.percent !== 0)),
        maxLength: maxLength(28)
      },
      podiel_cislo: {
        required: requiredIf(vm => (vm.percent !== 0)),
        maxLength: maxLength(8)
      },
      podiel_psc: {
        required: requiredIf(vm => (vm.percent !== 0)),
        numeric,
        maxLength: maxLength(5)
      },
      podiel_obec: {
        required: requiredIf(vm => (vm.percent !== 0)),
        maxLength: maxLength(35)
      },
      podiel_suhlas: { mustCheck }
    }
  },

  methods: {
    async processGet() {
      this.items = await this.restDataSource.getData(this.$route.params.userId, 'podiel')
    },
    async processSave() {
      await this.restDataSource.updateData(this.items, 'podiel')
    },

    setNull() {
      const el = this.items

      if (el.percent === 0) {
        el.podiel_ico = null
        el.podiel_pravna_forma = null
        el.podiel_obch_meno1 = null
        el.podiel_obch_meno2 = null
        el.podiel_ulica = null
        el.podiel_cislo = null
        el.podiel_psc = null
        el.podiel_obec = null
        el.podiel_suhlas = null

        this.$v.$reset()
      }

      if (this.$store.state.domain === '!jedno') {
        el.podiel_suhlas = '1'
      }
    },

    addZuskData() {
      const el = this.items

      el.podiel_ico = '45786259'
      el.podiel_pravna_forma = 'Občianske združenie'
      el.podiel_obch_meno1 = '"ZÚSK - Združenie účtovníkov'
      el.podiel_obch_meno2 = 'Slovenska"'
      el.podiel_ulica = 'Budatínska'
      el.podiel_cislo = '3916/24'
      el.podiel_psc = '85106'
      el.podiel_obec = 'Bratislava-Petržalka'
    }
  }
}
</script>
<style>
.percentLabel {
  padding-top: 63px;
  padding-left: 40px;
}
</style>
